module.exports = {
  phoneNumberSanitizer: str => `${str}`.replace(/[\D\s]/g, ''),
};
